/**
 * Central Registry API Service
 *
 * Provides typed access to miscellaneous entity info endpoints used by Admin Users.
 */

import { httpClient } from './http-client.service';
import type {
  ChannelTypes,
  DepartmentCodes,
  EntityInfoResponse,
} from '../types/central-registry';

class CentralRegistryAPIService {
  /**
   * Fetch list of channel types used in user forms.
   */
  async getChannelTypes(): Promise<ChannelTypes> {
    const response = await httpClient.get<EntityInfoResponse<ChannelTypes>>(
      'entityinfo',
      {
        params: { key: 'channel_type_values' },
      }
    );

    return response.data?.data?.value ?? [];
  }

  /**
   * Fetch department codes for dropdowns.
   */
  async getDepartmentCodes(): Promise<DepartmentCodes> {
    const response = await httpClient.get<EntityInfoResponse<DepartmentCodes>>(
      'entityinfo',
      {
        params: { key: 'user_department_codes' },
      }
    );

    return response.data?.data?.value ?? [];
  }
}

export const centralRegistryAPI = new CentralRegistryAPIService();
export { CentralRegistryAPIService };
